/**
 * Per-agreement-type persistence of the user's answers in the questions form.
 * Lets the user come back to an agreement type and continue where they left
 * off without re-typing parties, jurisdiction, etc.
 *
 * Keyed by agreement type id (e.g. "nda", "employment"). Custom agreements
 * use a per-instance id like "custom-1735690000" so they get a unique slot.
 *
 * Production should mirror this on the Signus backend so saved answers sync
 * across devices and the user's library of past agreements.
 */

/* global localStorage */

const KEY_PREFIX = 'signus.agreementAnswers.';

export function getSavedAnswers(typeId: string): Record<string, string> {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + typeId);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? (parsed as Record<string, string>) : {};
  } catch {
    return {};
  }
}

export function saveAnswers(typeId: string, answers: Record<string, string>): void {
  try {
    localStorage.setItem(KEY_PREFIX + typeId, JSON.stringify(answers));
  } catch {
    // Quota / privacy mode — fail silently.
  }
}

export function clearSavedAnswers(typeId: string): void {
  try {
    localStorage.removeItem(KEY_PREFIX + typeId);
  } catch {
    // noop
  }
}
